import { useI18n } from 'vue-i18n'

import { ref } from 'vue'

import { useClubRouter } from '@/features/router/useClubRouer.js'

export function dashboardLayoutHeaderRightAddItems() {
  const { t } = useI18n()

  const router = useClubRouter()

  function navigateTo(path) {
    router.push(path).then()
  }

  const rightItems = ref([
    {
      label: t('headerMenu.registerAthletes'),
      command: () => {
        navigateTo('/admin/people/register')
      },
    },
    {
      label: t('headerMenu.newPerson'),
      command: () => {
        navigateTo('/admin/people/new')
      },
    },
    {
      label: t('headerMenu.newAttendance'),
      command: () => {
        navigateTo('/admin/attendances/new')
      },
    },
    {
      label: t('headerMenu.newEvent'),
      command: () => {
        navigateTo('/admin/events/new')
      },
    },
    {
      label: t('headerMenu.newGroup'),
      command: () => {
        navigateTo('/admin/groups/new')
      },
    },
  ])

  return {
    rightItems,
  }
}
